module.exports = __webpack_public_path__ + "img/Mailbox4.e344f3a9.svg";